/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


export class GlobalScenario {
  id: number;
  globalScenarioName: string;
  gmid: string;
  timeStamp: string;
  bpPub: string;

}
